<template>
  <div
    class="result"
    :style="result.customOptions?.style"
    @click="handleClick"
  >
    <div
      v-if="result.customOptions.iconType !== 'none'"
      class="result-icon"
    >
      <!-- For rendering component-based icons -->
      <component
        :is="result.customOptions.icon"
        v-if="result.customOptions.iconType === 'vue'"
        :icon-height="result.customOptions.iconHeight"
      />
      <!-- PNG icons -->
      <img
        v-else-if="result.customOptions.icon"
        :src="result.customOptions.icon"
      >
      <!-- Fallback to Google's 'G' icon-->
      <GoogleIcon
        v-else
        class="googleIcon"
      />
    </div>
    <SearchResultLabel
      :content="result.customOptions.label"
      class="result-label"
    />
  </div>
</template>

<script>
// Components
import SearchResultLabel from '@/components/SearchBar/sections/SearchResultLabel.vue';
import GoogleIcon from '@/components/svgs/GoogleIcon.vue';

export default {
  name: 'SearchResult',
  components: {
    SearchResultLabel,
    GoogleIcon,
  },
  props: {
    result: {
      default: function() {
        return {};
      },
      type: Object,
    },
  },
  methods: {
    /**
     * Receives click events from result component and triggers result's custom click handler callback
     */
    handleClick() {
      this.result.customOptions.clickHandler(this.result);
    },
  },
};
</script>

<style scoped lang="scss">
.result {
    padding: 20px 10px;
    height: 45px;
    width: 100%;
    justify-content: center;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      background-color: #F5F5F5;
    }

    &-icon {
      float: left;
      height: 45px;
      width: 10%;
      height: 24px;
      width: 24px;

      img {
        width: 24px;
        height: 24px;
      }
    }

    &-label {
      padding: 6px 16px 6px 12px;
      width: 90%;
      height: 45px;
      padding-left: 5px;
      display: flex;
      vertical-align: middle;
      align-items: center;
    }

    .googleIcon {
      vertical-align: middle;
      width: 24px;
      height: 24px;
    }
}
</style>
